import './styles.scss'

let Loading = (props: { show: boolean }) => {
	return (
		props.show ? (
			<div className={`componentsLoading d-flex justify-content-center align-items-center`}>
				<div className={`card border-0`}>
					<div className={`card-body`}>
						{/* @ts-ignore */}
						<i className={`loadingIcon fas fa-spinner`} />
					</div>
				</div>
			</div>
		) : null
	)
}

export default Loading